<template>
  <div class="ts-app-shell_fh">
  <RegistrationQuestionnaire :currentPage="currentPageStep">
    <div class="check-list-form">
      <div class="content-type">
        <span>Intake Information</span>
      </div>
      <el-form
        :model="registrationAnswer"
        @submit.native.prevent="updateRegistrationAnswers"
      >
        <p class="heavy-text">Household Information</p>
        <div class="content-item">
          <el-row>
            <el-checkbox v-model="doNotProvideHouseholdInfo">
              I do not wish to provide household information
            </el-checkbox>
          </el-row>
        </div>
        <div v-if="displayHouseholdInfo">
          <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  What is your income as an individual?
                </label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'HouseholdInfo.IncomeAsAnIndividual'
                    )
                  "
                >
                    <currency-input
                      :decimal-length="0"
                      :currency="selectedCurrency"
                      style="width: 200px"
                      class="el-input__inner"
                      v-model="ConvertedIncomeAsAnIndividual"
                    />
                </el-form-item>
              </div>
            </el-row>
          </div>
          <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  What is your household income?
                </label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'HouseholdInfo.HouseholdIncome'
                    )
                  "
                >
                    <currency-input
                      :decimal-length="0"
                      :currency="selectedCurrency"
                      style="width: 200px"
                      class="el-input__inner"
                      v-model="ConvertdHouseholdIncome"
                    />
                </el-form-item>
              </div>
            </el-row>
          </div>
          <div class="content-item">
            <el-row>
              <el-col :xl="24" :lg="24" :md="24" :sm="24">
                <label role="text">Number of individuals living in your household?</label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'HouseholdInfo.NumberOfIndividuals'
                    )
                  "
                >
                  <el-select v-model="registrationAnswer.householdInfo.numberOfIndividuals" placeholder="Select">
                    <el-option
                      v-for="item in numberOfIndividualOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  Do you have any dependents?
                </label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'HouseholdInfo.AnyDependents'
                    )
                  "
                >
                  <el-radio-group
                    v-model="registrationAnswer.householdInfo.anyDependents"
                    class="ml-4"
                  >
                    <el-radio :label="0" size="large">Yes</el-radio>
                    <el-radio :label="1" size="large">No</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-row>
          </div>
          <div class="content-item" v-if="registrationAnswer.householdInfo.anyDependents === 0">
            <el-row>
              <el-col :xl="24" :lg="24" :md="24" :sm="24">
                <label role="text">If yes, how many dependents do you have?</label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'HouseholdInfo.NumberOfDependents'
                    )
                  "
                >
                  <el-select v-model="registrationAnswer.householdInfo.numberOfDependents" placeholder="Select">
                    <el-option
                      v-for="item in numberOfIndividualOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <p class="heavy-text">Public Assistance</p>
        <div class="content-item">
          <el-row>
            <div class="mb-2 flex items-center text-sm">
              <label role="text">
                Has your household received Temporary Assistance for Needy Families (TANF) payments?
              </label>
              <el-form-item
                :error="
                  retrieveFieldError(
                    modelState,
                    'PublicAssistance.ReceivedTANF'
                  )
                "
              >
                <el-radio-group
                  v-model="registrationAnswer.publicAssistance.receivedTANF"
                  class="ml-4"
                >
                  <el-radio :label="0" size="large">Yes</el-radio>
                  <el-radio :label="1" size="large">No</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </el-row>
        </div>
        <div class="content-item">
          <el-row>
            <div class="mb-2 flex items-center text-sm">
              <label role="text">
                Have you been determined eligible for or received Supplemental Nutrition Assistance Program assistance (SNAP
                formerly known as Food Stamps)?
              </label>
              <el-form-item
                :error="
                  retrieveFieldError(
                    modelState,
                    'PublicAssistance.ReceivedSNAP'
                  )
                "
              >
                <el-radio-group
                  v-model="registrationAnswer.publicAssistance.receivedSNAP"
                  class="ml-4"
                >
                  <el-radio :label="0" size="large">Yes</el-radio>
                  <el-radio :label="1" size="large">No</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </el-row>
        </div>
        <div class="content-item">
          <el-row>
            <div class="mb-2 flex items-center text-sm">
              <label role="text">
                Have you received General Assistance Payments?
              </label>
              <el-form-item
                :error="
                  retrieveFieldError(
                    modelState,
                    'PublicAssistance.ReceivedGAP'
                  )
                "
              >
                <el-radio-group
                  v-model="registrationAnswer.publicAssistance.receivedGAP"
                  class="ml-4"
                >
                  <el-radio :label="0" size="large">Yes</el-radio>
                  <el-radio :label="1" size="large">No</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </el-row>
        </div>
        <div class="content-item">
          <el-row>
            <div class="mb-2 flex items-center text-sm">
              <label role="text">
                Have you received Refugee Cash Assistance Payments?
              </label>
              <el-form-item
                :error="
                  retrieveFieldError(
                    modelState,
                    'PublicAssistance.ReceivedRCAP'
                  )
                "
              >
                <el-radio-group
                  v-model="registrationAnswer.publicAssistance.receivedRCAP"
                  class="ml-4"
                >
                  <el-radio :label="0" size="large">Yes</el-radio>
                  <el-radio :label="1" size="large">No</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </el-row>
        </div>
        <div class="content-item action-section">
          <el-row>
            <el-col span="8">
              <el-button
                class="ts-btn ts-btn-outline wioa-btn-outline"
                @click="backToDashboard"
              >
                Previous
              </el-button>
            </el-col>
            <el-col span="8">
              <el-button
                class="ts-btn ts-btn-secondary"
                @click="updateRegistrationAnswers"
              >
                Next
              </el-button>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </div>
  </RegistrationQuestionnaire>
  <TSLoading
      :active="isLoading"
      :defaultMessage="'Please wait...'"
      :altMessage="'Please hold on for a moment while we process your data...'"
    />
  </div>
</template>

<script>
import RegistrationQuestionnaire from "../../component/RegistrationQuestionnaire.vue";
import TSLoading from "../../../../components/TSLoading.vue";

export default {
  components: { RegistrationQuestionnaire, TSLoading },
  data(){
    return{
      ConvertedIncomeAsAnIndividual: null,
      ConvertdHouseholdIncome: null,
      selectedCurrency: "USD",
      modelState: {},
      isLoading: false,
      registrationAnswer: {
        priorityOfService: {},
        militaryService: {},
        veteranInfo: {},
        transitioningServiceMembers: {},
        militaryMemberSpouse: {},
        disability: {},
        householdInfo: {},
        publicAssistance: {},
      },
      householdInfoEmpty: {
        provideHouseholdInfo: true,
        incomeAsAnIndividual: null,
        householdIncome: null,
        numberOfIndividuals: null,
        anyDependents: null,
        numberOfDependents: null,
      },
      publicAssistanceEmpty: {
        receivedTANF: null,
        receivedSNAP: null,
        receivedGAP: null,
        receivedRCAP: null,
      },
      jobSeekerId: null,
      numberOfIndividualOptions: [{
          value: '1',
          label: '1'
        }, {
          value: '2',
          label: '2'
        }, {
          value: '3',
          label: '3'
        }, {
          value: '4',
          label: '4'
        }, {
          value: '5',
          label: '5'
        }, {
          value: '6',
          label: '6'
        }, {
          value: '7',
          label: '7'
        }, {
          value: '8+',
          label: '8+'
        }],
      doNotProvideHouseholdInfo: false,
    }
  },
  computed: {
    currentPageStep() {
      return this.$route.meta.currentPage;
    },
    displayHouseholdInfo() {
      if (this.doNotProvideHouseholdInfo)
        return false;
      else
        return true;
    },
    skipStepTwo() {
      return this.registrationAnswer.priorityOfService.activeMemberOfTheMilitary === 1 &&
        this.registrationAnswer.priorityOfService.spouseOfAnActiveMemberOfTheMilitary === 1 &&
        this.registrationAnswer.priorityOfService.discloseDisability === 1;
    },
  },
  created() {
    window.scrollTo(0,0);
    this.isLoading = true;
    this.jobSeekerId = this.$store.state.account.applicant_user_info.jobSeekerId;
    this.$store
      .dispatch("jobseeker/getRegistrationAnswerByJobSeekerId", this.jobSeekerId)
      .then((res) => {
        if (res === null || res === undefined || res.priorityOfService === null) {
          this.$router.push({ name: "RegistrationQuestionnaireOne" });
        } else {
          this.registrationAnswer = res;
          this.doNotProvideHouseholdInfo = this.registrationAnswer.householdInfo === null ? false : !this.registrationAnswer.householdInfo.provideHouseholdInfo;
          this.registrationAnswer.householdInfo = this.registrationAnswer.householdInfo === null 
            ? this.householdInfoEmpty 
            : this.registrationAnswer.householdInfo;
          this.registrationAnswer.publicAssistance = this.registrationAnswer.publicAssistance === null 
            ? this.publicAssistanceEmpty 
            : this.registrationAnswer.publicAssistance;

          if (this.registrationAnswer.householdInfo.incomeAsAnIndividual) {
             this.ConvertedIncomeAsAnIndividual = this.registrationAnswer.householdInfo.incomeAsAnIndividual;
          }

          if (this.registrationAnswer.householdInfo.householdIncome) {
             this.ConvertdHouseholdIncome = this.registrationAnswer.householdInfo.householdIncome;
          }
        }
      })
      .finally(() => {
        this.isLoading = false;
      });
  },
  methods: {
    backToDashboard() {
      if (this.skipStepTwo) {
        this.$router.push({ name: "RegistrationQuestionnaireOne" });
      } else {
        this.$router.push({ name: "RegistrationQuestionnaireTwo" });
      }
    },
    updateRegistrationAnswers() {
      this.isLoading = true;
      this.registrationAnswer.validatePageType = 3;

      this.registrationAnswer.householdInfo.provideHouseholdInfo = this.displayHouseholdInfo;
      this.registrationAnswer.householdInfo.numberOfDependents = this.registrationAnswer.householdInfo.anyDependents === 0
        ? this.registrationAnswer.householdInfo.numberOfDependents
        : null;

      if (this.ConvertedIncomeAsAnIndividual) {
        this.registrationAnswer.householdInfo.incomeAsAnIndividual = this.ConvertedIncomeAsAnIndividual.toString();
      }

      if (this.ConvertdHouseholdIncome) {
        this.registrationAnswer.householdInfo.householdIncome = this.ConvertdHouseholdIncome.toString();
      }

      this.$store
        .dispatch("jobseeker/updateRegistrationAnswer", this.registrationAnswer)
        .then(res => {
          if (res) {
            this.$router.push({ name: "RegistrationQuestionnaireFour" });
          }
        })
        .catch(res => {
          this.modelState = res;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
